export const canAccessPlaybackTab = (tabName, { isAdmin = false, entitlements = null } = {}) => {
  if (isAdmin) return true;
  if (tabName === 'Scheduler') return entitlements?.scheduler_access === true;
  if (tabName === 'Fallback Playlist') return entitlements?.fallback_management === true;
  return true;
};
